<div class="card-white">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">Tipos de Producto</h2>
    </div>
    <div class="button-section">
      <div class="p-input-icon-left search-input">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." appPermissionControl="P198K0001" />
        </span>
      </div>
      <button mat-flat-button class="btn-new" (click)="openForm()" appPermissionControl="P198B0001">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
      <button mat-flat-button class="btn-back" (click)="openCopiarDialog()" appPermissionControl="P198B0004">
        <mat-icon>content_copy</mat-icon>
        Copiar
      </button>
    </div>
  </div>

  <div>
    <p-table
      #dt
      [value]="dataSource.data"
      [columns]="columns"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 25, 50]"
      [scrollable]="true"
      scrollHeight="400px"
      styleClass="p-datatable-gridlines"
      [resizableColumns]="true"
      [autoLayout]="true"
      responsiveLayout="scroll"
      [globalFilterFields]="['producto', 'descripcion', 'frecuenciaPago', 'moneda']"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [sortField]="'producto'"
      [sortOrder]="1"
      appPermissionControl="P198T0001"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P198C0001">
            {{ col.header }}
            <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns" class="td-prime">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'actions'">
                <div class="d-flex gap-2 justify-content-center">
                  <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" (click)="openForm(rowData)" appPermissionControl="P198B0002"></button>
                  <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="delete(rowData)" appPermissionControl="P198B0003"></button>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] || 'N/A' }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length" class="text-center td-prime">
            <div *ngIf="allData == 0 && !loading">No hay datos para mostrar</div>
            <p-progressSpinner
              *ngIf="loading"
              [style]="{ width: '50px', height: '50px' }"
              styleClass="custom-spinner"
              strokeWidth="8"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            >
            </p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [(visible)]="displayCopiarDialog" [style]="{ width: '400px' }" [modal]="true" [draggable]="false"
  [resizable]="false" (onHide)="onCopiarDialogClosed()" header="Copiar Tipo de Crédito">
  <app-copiar-tipos-credito-dialog (formResult)="onCopiarDialogClosed($event)"></app-copiar-tipos-credito-dialog>
</p-dialog>

<p-toast position="bottom-right"></p-toast>
